export const getDefault = ({ lang }) => {
  const schema = {
    name: 'Xperimenta',
    title: lang === 'pt' ? 'Cursos' : 'Courses',
    sessions: [],
  };
  return schema;
};
